<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <AnswerPopup
          :show="showAnswerPopup"
          @finish="onfinish"
          :userInfoCurrent="userInfoCurrent"
          :ParentIdCurrent="ParentIdCurrent"
          :productInfoIdCurrent="productInfoIdCurrent"
          :persianProductName="persianProductName"
          :lastAnswer="lastAnswer"
        ></AnswerPopup>
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('ProductName'), sort: 'ProductName' },
            { title: $t('Description'), sort: 'Description' },
            { title: $t('UserName'), sort: 'UserName' },
            { title: $t('LikedCount'), sort: 'LikedCount' },
            { title: $t('DisLikedCount'), sort: 'DisLikedCount' },
            { title: $t('Answer'), sort: 'Answer' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
            { title: $t('Action') }
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 22%">{{ row.productInfo.persianName }}</td>
            <td style="width: 22%">
              {{ row.description | truncate(60) }}
            </td>
            <td style="width: 11%">
              {{ row.userInfo.fullName }}
            </td>
            <td style="width: 9%">
              {{ row.likedCount }}
            </td>
            <td style="width: 9%">
              {{ row.disLikedCount }}
            </td>
            <td style="width: 9%">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                class="bordered-btn"
                @click.prevent="onShowAnswerPopup(row)"
                v-has-permission="permission264"
                >{{ $t("Answer") }}</vs-button
              >
            </td>
            <td style="width: 9%; direction: ltr">
               {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
            </td>
            <td style="width: 9%">
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-eye"
                @click.prevent="modifyForum(row)"
                class="d-inline"
                v-has-permission="permission265"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
    <modify-popup
      :show="ModifyPopup"
      :model="modalModel"
      @finish="onfinish"
    ></modify-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
import AnswerPopup from "./AnswerPopup.vue";

export default {
  name: "Content_management_Pending_Index",
  components: {
    ModifyPopup,
    AnswerPopup,
    DataGrid
  },
  data() {
    return {
      permission264: "CreateForum",
      permission265: "ModifyForum",
      userInfoCurrent: {},
      ParentIdCurrent: "",
      productInfoIdCurrent: "",
      ModifyPopup: false,
      showAnswerPopup: false,
      modalModel: {},
      lastAnswer: "",
      gridDataSource: {
        type: "app",
        service: "CMS/api/ForumsQuery?forumStaus=0&"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  },

  methods: {
    modifyForum(model) {
      this.modalModel = {
        id: model.id,
        description: model.description
      };
      this.ModifyPopup = true;
    },
    onShowAnswerPopup(row) {
      this.userInfoCurrent = row.userInfo;
      this.ParentIdCurrent = row.id;
      this.productInfoIdCurrent = row.productInfo.id;
      this.persianProductName = row.productInfo.persianName;
      this.showAnswerPopup = true;
      if (row.children.length != 0) {
        this.lastAnswer = row.children[row.children.length - 1].description;
      } else this.lastAnswer = "";
    },
    onfinish() {
      this.ModifyPopup = false;
      this.showAnswerPopup = false;
      this.$refs.grid.renderGrid();
    }
  }
};
</script>
